import { useDispatch, useSelector } from 'react-redux';
import { getConfigs } from '../../../appRedux/actions';
//import { useIdleTimer } from 'react-idle-timer/dist/index.legacy.esm.js';
import { useIdleTimer } from 'react-idle-timer'
import { useEffect, useRef } from 'react';
import { Modal } from 'antd';
import { useLocation } from 'react-router-dom';
import { buttonLabel, freezeScreenModal, UrlPaths } from '../../../constants';

export const FreezeScreen = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { configs } = useSelector((state) => state.configs);

  const idleTriggerred = useRef(false);

  useEffect(() => {
    dispatch(getConfigs());
  }, [dispatch]);

  const freezeScreen = (configs?.abscenceTime?.freezeScreen || 300) * 1000;

  const onIdle = () => {
    if (idleTriggerred.current) return;
    if (location.pathname.startsWith(UrlPaths.AGENDA)) {
      idleTriggerred.current = true;
      Modal.warning({
        title: freezeScreenModal.title,
        content: <p>{freezeScreenModal.body}</p>,
        closable: false,
        maskClosable: false,
        okText: buttonLabel.continue,
        onOk() {
          idleTriggerred.current = false;
          activate();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        },
      });
    }
  };

  const { activate } = useIdleTimer({
    timeout: freezeScreen,
    onIdle,
    throttle: 500,
  });

  if (!location.pathname.startsWith(UrlPaths.AGENDA)) {
    return null;
  }

  return null;
};
